import { apiClient } from './client'
import type { MaterialAcquisition, ToolAcquisition } from './types'

// ---- Material acquisitions ------------------------------------------------

export const listMaterialAcquisitions = async (
  projectId: string
): Promise<MaterialAcquisition[]> => {
  const response = await apiClient.get<MaterialAcquisition[]>(
    `/api/v1/me/followings/${projectId}/material-acquisitions`
  )
  return response.data
}

interface AcquireMaterialPayload {
  snapshotAttachmentId: string
  lockedUnitPriceCents?: number | null
}

export const acquireMaterial = async (
  projectId: string,
  payload: AcquireMaterialPayload
): Promise<MaterialAcquisition> => {
  const body: Record<string, unknown> = { snapshotAttachmentId: payload.snapshotAttachmentId }
  if (payload.lockedUnitPriceCents != null) {
    body.lockedUnitPriceCents = payload.lockedUnitPriceCents
  }
  const response = await apiClient.post<MaterialAcquisition>(
    `/api/v1/me/followings/${projectId}/material-acquisitions`,
    body
  )
  return response.data
}

export const unacquireMaterial = async (
  projectId: string,
  snapshotAttachmentId: string
): Promise<void> => {
  await apiClient.delete(
    `/api/v1/me/followings/${projectId}/material-acquisitions/${snapshotAttachmentId}`
  )
}

export const updateMaterialPrice = async (
  projectId: string,
  snapshotAttachmentId: string,
  lockedUnitPriceCents: number | null
): Promise<MaterialAcquisition> => {
  const response = await apiClient.patch<MaterialAcquisition>(
    `/api/v1/me/followings/${projectId}/material-acquisitions/${snapshotAttachmentId}`,
    { lockedUnitPriceCents }
  )
  return response.data
}

// ---- Tool acquisitions ----------------------------------------------------

export const listToolAcquisitions = async (projectId: string): Promise<ToolAcquisition[]> => {
  const response = await apiClient.get<ToolAcquisition[]>(
    `/api/v1/me/followings/${projectId}/tool-acquisitions`
  )
  return response.data
}

interface AcquireToolPayload {
  catalogToolId: string
  lockedUnitPriceCents?: number | null
}

export const acquireTool = async (
  projectId: string,
  payload: AcquireToolPayload
): Promise<ToolAcquisition> => {
  const body: Record<string, unknown> = { catalogToolId: payload.catalogToolId }
  if (payload.lockedUnitPriceCents != null) {
    body.lockedUnitPriceCents = payload.lockedUnitPriceCents
  }
  const response = await apiClient.post<ToolAcquisition>(
    `/api/v1/me/followings/${projectId}/tool-acquisitions`,
    body
  )
  return response.data
}

export const unacquireTool = async (projectId: string, catalogToolId: string): Promise<void> => {
  await apiClient.delete(`/api/v1/me/followings/${projectId}/tool-acquisitions/${catalogToolId}`)
}

export const updateToolPrice = async (
  projectId: string,
  catalogToolId: string,
  lockedUnitPriceCents: number | null
): Promise<ToolAcquisition> => {
  const response = await apiClient.patch<ToolAcquisition>(
    `/api/v1/me/followings/${projectId}/tool-acquisitions/${catalogToolId}`,
    { lockedUnitPriceCents }
  )
  return response.data
}
